import React, { lazy, Suspense } from 'react';
import Loading from '../Loading/Loading';

// Dynamically import theme components
const Theme1 = lazy(() => import('./Theme1'));
const Theme2 = lazy(() => import('./Theme2'));
const Theme3 = lazy(() => import('./Theme3'));
const Theme6 = lazy(() => import('./Theme6'));
const Theme7 = lazy(() => import('./Theme7'));
const Theme8 = lazy(() => import('./Theme8'));
const Theme9 = lazy(() => import('./Theme9'));
const PhotoTheme = lazy(() => import('./PhotoTheme'));

const DigitalMenuAI = lazy(() => import('./DigitalMenuAI'));

// Theme mapping object for dynamic rendering
const THEME_COMPONENTS = {
  'theme1': Theme1,
  'theme2': Theme2,
  'theme3': Theme3,
  'digitalmenuai': DigitalMenuAI,
  'theme6' : Theme6,
  'theme7' : Theme7,
  'theme8' : Theme8,
  'theme9' : Theme9,
  'phototheme' : PhotoTheme,
};

// Dynamic Theme Renderer
const ThemeRenderer = ({ theme, orgInfo }) => {
  console.log("🚀 ~ ThemeRenderer ~ theme:", theme)
  // Normalize theme title to lowercase
  const themeKey = theme?.title?.toLowerCase();
  console.log("themekey",themeKey)
  // Select the appropriate theme component
  const SelectedTheme = THEME_COMPONENTS[themeKey];
  console.log("🚀 ~ ThemeRenderer ~ SelectedTheme:", SelectedTheme)

  if (!SelectedTheme) {
    console.warn(`No theme found for: ${themeKey}`);
    return null;
  }

  return (
    <Suspense fallback={<Loading />}>
      <SelectedTheme orgInfo={orgInfo} />
    </Suspense>
  );
};

export default {
  ThemeRenderer,
  Theme1,
  Theme2,
  Theme3,
  DigitalMenuAI,
  Theme6,
  Theme7,
  Theme8,
  Theme9,
  PhotoTheme
};